export interface GSDDAuditOverride {
    packageID: number;
    auditChance: number;
    created?: Date;
    createdBy?: string;
    updated?: Date;
    updatedBy?: string;
}

export class GSDDAuditOverride {
    packageID: number = 0;
    auditChance: number = 0;
    created?: Date;
    createdBy?: string;
    updated?: Date;
    updatedBy?: string;

    constructor(obj?: GSDDAuditOverride) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
}
